import { useState as r, useCallback as n, useEffect as l } from "react";
import { a as o } from "./libServer-S4LVM0ns.js";
function h(t) {
  const [e, i] = r(!1), s = n(() => i(!0), []), d = n(() => i(!1), []), u = n(() => i((w) => !w), []);
  return { value: e, setValue: i, setTrue: s, setFalse: d, toggle: u };
}
function a() {
  const [t, e] = r({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return l(() => {
    function i() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), t;
}
function p() {
  const { width: t } = a();
  let e = "desktop";
  return t && t <= o.MOBILE ? e = "mobile" : t && t <= o.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop"
  };
}
export {
  h as D,
  p
};
